import { takeEvery, put } from "redux-saga/effects";
import {
    REQUEST_ACTIVITY_QUESTIONS,
    REQUEST_EXISTING_ACTIVITY_QUESTIONS,
    requestExistingActivityQuestionsSuccess,
    requestActivityQuestionsSuccess,
    requestActivityQuestionsError,
} from "./activityQuestionsActions";
import { makeApiCall } from "../helpers";
import taskServices from "../../services/taskServices";

export function* watchActivityQuestions() {
    yield takeEvery(REQUEST_ACTIVITY_QUESTIONS, fetchActivityQuestions);
}
export function* watchActivityExistingQuestions() {
    yield takeEvery(REQUEST_EXISTING_ACTIVITY_QUESTIONS, fetchExistingActivityQuestions);
}

function* fetchActivityQuestions(action) {
    try {
        const response = yield makeApiCall(taskServices.getActivityQuestions, action.payload.activityId);
        yield put(requestActivityQuestionsSuccess(response, action.payload.followUpUUID));
    } catch (error) {
        console.error("Error fetching activity questions", error);
        yield put(requestActivityQuestionsError(error, action.payload.followUpUUID));
    }
}
function* fetchExistingActivityQuestions(action) {
    try {
        const response = yield makeApiCall(taskServices.getMultipleWorkActivityInformation, action.payload.referenceTicketNumber);
        if (response?.body?.[0]) {
            yield put(
                requestExistingActivityQuestionsSuccess(
                    response.body[0],
                    action.payload.followUpUUID,
                    JSON.parse(response.body[0]?.activityQuestionJson),
                ),
            );
        }
    } catch (error) {
        console.error("Error fetching activity questions", error);
        yield put(requestActivityQuestionsError(error, action.payload.followUpUUID));
    }
}
